<div>
</div>
<form [formGroup]="direccionInfo" class="row">
  <div *ngIf="alias.length > 0" class="col-12">
    <mat-radio-group formControlName="predeterminada" class="col-12 mb-3">
      <mat-radio-button *ngFor="let name of alias, let ix=index" (click)="setAddress(address[ix])" checked="address[ix]?.isDefault" [value]="name">{{ name }}</mat-radio-button>
      <mat-radio-button (click)="setAddress([])" [value]="'nueva'">Agregar dirección</mat-radio-button>
    </mat-radio-group>
  </div>
  <mat-form-field floatLabel="always" class="col-xs-6 col-sm-6 col-md-4 col-lg-4" *ngIf="!isNew">
    <mat-label>Alias</mat-label>
    <input
      matInput
      class="example-right-align"
      formControlName="alias"
    />
  </mat-form-field>
  <mat-form-field floatLabel="auto" class="col-xs-6 col-sm-6 col-md-4 col-lg-4">
    <mat-label>Calle</mat-label>
    <input
      matInput
      type="text"
      class="example-right-align"
      formControlName="calle"
      (blur)="sendData()"
    />
  </mat-form-field>
  <mat-form-field floatLabel="always" class="col-xs-6 col-sm-6 col-md-4 col-lg-4">
    <mat-label>Colonia</mat-label>
    <input
      matInput
      formControlName="colonia"
      (blur)="sendData()"
    />
  </mat-form-field>
  <mat-form-field floatLabel="always" class="col-xs-6 col-sm-6 col-md-4 col-lg-4">
    <mat-label>Número Exterior</mat-label>
    <input
      matInput
      type="text"
      class="example-right-align"
      placeholder="0"
      formControlName="exterior"
      (blur)="sendData()"
    />
  </mat-form-field>
  <mat-form-field floatLabel="always" class="col-xs-6 col-sm-6 col-md-4 col-lg-4">
    <mat-label>No. Interior</mat-label>
    <input
      matInput
      type="text"
      class="example-right-align"
      formControlName="interior"
      (blur)="sendData()"
    />
  </mat-form-field>
  <mat-form-field floatLabel="always" class="col-xs-6 col-sm-6 col-md-4 col-lg-4">
    <mat-label>C.P.</mat-label>
    <input
      matInput
      type="text"
      class="example-right-align"
      formControlName="cp"
      (blur)="sendData()"
    />
  </mat-form-field>
  <mat-form-field floatLabel="auto" class="col-xs-6 col-sm-6 col-md-4 col-lg-4">
    <mat-label>Ciudad</mat-label>
    <input
      matInput
      type="text"
      class="example-right-align"
      placeholder="0"
      formControlName="ciudad"
      (blur)="sendData()"
    />
  </mat-form-field>
  <mat-form-field floatLabel="auto" class="col-xs-6 col-sm-6 col-md-4 col-lg-4">
    <mat-label>Delegación/Municipio</mat-label>
    <input
      matInput
      type="text"
      class="example-right-align"
      formControlName="localidad"
      (blur)="sendData()"
    />
  </mat-form-field>
  <mat-form-field floatLabel="auto" class="col-xs-6 col-sm-6 col-md-4 col-lg-4">
    <mat-label>Número de contacto</mat-label>
    <input
      matInput
      type="text"
      class="example-right-align"
      formControlName="contact"
      (blur)="sendData()"
    />
  </mat-form-field>

  <button class="btn btn-primary mt-3" *ngIf="showSave" (click)="saveInfo()">Guardar Dirección</button>
</form>
